import Vue from 'vue'
import Router from 'vue-router'

import store from '@/vuex/store'
import Error404 from './views/Errors/404WithHeader'
import Error404NH from './views/Errors/404NotHeader'
import Error403NH from './views/Errors/403NotHeader'
import rrhhredirect from './views/Errors/rrhhHandler'

// views
import Main from './views/Main'
import PickUpModule from './modules/Pickup/router'
import HomeModule from './modules/Home/router'
import DocumentsModule from './modules/Documents/router'
import UploadFileModule from './modules/UploadFile/router'
import LicensesModule from './modules/Licenses/router'
import SearchModule from './modules/Search/router'
import Upload from './views/Upload'
import AuthModule from './modules/Auth/router'
import URLQueryString from "@/utils/queryString";
import organizationModule from './modules/Manager/router';
import SelfServiceModule from "./modules/SelfService/router";
import CertificatesModule from './modules/Certificates/router';
import employeeModule from './modules/Employee/router';
import payrollModule from './modules/Payroll/router'
import linkUser from './modules/LinkUser/router'
import {isEmpty} from 'lodash'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/rrhhredirect',
      name: 'rrhhredirect',
      component: rrhhredirect,
      meta: {
        requiresAuth: true,
        requiresPermission: false
      }
    },
    {
      name: 'keyCloak',
      path: '/keyCloak',
      component: () => import('@/modules/Auth/components/keyCloak/authTokenEntry.vue'),
      meta: {
      showMenu: false,
      requiresAuth: false,
      requiresPermission: false
      }
    },
    {
      name: 'authToken',
      path: '/auth-token',
      component: () => import('@/modules/Auth/components/keyCloak/ConnectTokenEntry.vue'),
      meta: {
      showMenu: false,
      requiresAuth: false,
      requiresPermission: false
      }
    },
    ...AuthModule,
    {
      path: '/',
      name: 'main',
      component: Main,
      children: [
        HomeModule,
        DocumentsModule,
        PickUpModule,
        UploadFileModule,
        LicensesModule,
        SearchModule,
        organizationModule,
        employeeModule,
        payrollModule,
        linkUser,
        {
          path: '/upload',
          name: 'upload',
          component: Upload,
          meta: {
            showMenu: false,
            requiresAuth: true,
            requiresPermission: true,
            action: 77,
            titleHeader: 'Enviar documento'
          }
        },
        {
          name: 'task-manager',
          path: '/v3/task-manager',
          meta: {
            showMenu: false,
            requiresAuth: false ,
            requiresPermission: false,
            titleHeader: 'Bandeja de tareas'
          }
        },
        {
          name: 'new-dashboard',
          path: '/v3',
          meta: {
            showMenu: false,
            requiresAuth: true ,
            requiresPermission: false,
            // action: 307,
            titleHeader: 'home'
          }
        },
        ...SelfServiceModule,
        ...CertificatesModule,
      ],
      meta: {
        showMenu: true,
        requiresAuth: true,
        requiresPermission: false
      }
    },
    {
      path: '/media/pdf/privacidad.pdf',
      name: 'privacidad',
      meta: {
        showMenu: false,
        requiresAuth: true
      }
    },
    {
      path: '/403',
      name: '403',
      component: Error403NH,
      meta: {
        requiresAuth: true,
        requiresPermission: false,
        showMenu: true
      }
    },
    {
      path: '/404',
      name: '404',
      component: Error404,
      meta: {
        requiresAuth: true,
        requiresPermission: false
      }
     },
    {
      path: '/404NH',
      name: '404NH',
      component: Error404NH,
      meta: {
        requiresAuth: true,
        requiresPermission: false
      }
    },
    {
      path: '/sichern-connect-error',
      name: 'SichernConnectError',
      component: () => import('@/views/Errors/SichernConnectError.vue'),
      meta: {
        requiresAuth: false,
        requiresPermission: false
      }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

router.afterEach(async (to) => {
  if (to.name === 'mobileLoginSuccess') {
    const vm = router.app
    const targetRoute = '/v3/'
    await vm.$nextTick()
    return router.push(targetRoute)
  }
})

const SURVICATE_AUTH_PATTERN = /(?:^|\/)(login(?:-temp)?|logout|auth|first[Ll]ogin|forgot[Pp]assword|reset[Pp]assword|user[Bb]lock|mfa|key[Cc]loak|auth-token|password[Ee]xpired|checkingAccountKeyCloak|redirect|idp|rrhhredirect|sichern-connect-error)(?:\/|$)/

router.beforeEach(async(to, from, next) => {
  if (from.name && SURVICATE_AUTH_PATTERN.test(to.path) && window._sva) {
    next(false)
    const base = (process.env.BASE_URL || '/').replace(/\/$/, '')
    window.location.href = window.location.origin + base + to.fullPath
    return
  }

  let jwt = store.getters.getJwt
  let firstLogin = store.getters.getUser.ingreso
  let notOnboarding = store.getters.getStateNotOnboarding
  let checkUserEmployee = store.getters.getCheckUserEmployee
  let licensesAccess = store.getters.getUser.estado_empresa != 3
  let queryString = new URLQueryString(window.location.search)

  if (to.name === 'keyCloak' && isEmpty(jwt)) {
    return next()
  }

  if (jwt == '' && to.matched.some(record => record.meta.requiresAuth)) {
    const lsJwt = localStorage.getItem('jwt')
    if (lsJwt) {
      store.dispatch('setJwt', { jwt: lsJwt })
      jwt = lsJwt
    } else {
      return next('/auth')
    }
  }

  if (jwt !== '' && (!notOnboarding || Object.keys(store.getters.getUser).length === 0)) {
    try {
      await store.dispatch('setProfile')
      const profile = store.state.profile || {}
      store.dispatch('setUser', { user: profile })
      await store.dispatch('setActions')
      store.dispatch('setStateNotOnboarding', true)
      store.dispatch('setCheckUserEmployee', true)
      firstLogin = store.getters.getUser.ingreso
      notOnboarding = store.getters.getStateNotOnboarding
      checkUserEmployee = store.getters.getCheckUserEmployee
    } catch (error) {
      store.dispatch('clearState')
      return next('/auth')
    }
  }
  if (to.name === 'task-manager') {
    window.location.href = window.location.origin + '/v3/tasks-manager';
  } 

  if (to.name === 'new-dashboard') {
    if (window.location.pathname !== '/v3') {
      window.location.href = window.location.origin + '/v3';
    } else {
      next();
    }
  } 
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (firstLogin === 0 && to.name === 'firstLogin') {
      return next()
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name === 'userBlock' && notOnboarding) {
      return next()
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name === 'passwordExpired' && jwt) {
      return next()
    }
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(to.name === 'authSAML' && jwt) {
      return next()
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name === 'mfaEmailVerification' && jwt) {
      return next()
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name === 'mfaCodeVerification' && jwt) {
      return next()
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name === 'mfaUserBlock' && jwt) {
      return next()
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name === 'logout' && jwt) {
      return next()
    }
    if (to.name === 'logout' && jwt === '') {
      return next('/login')
    }
  }

  if (
      queryString.has('SAMLRequest') &&
      queryString.has('RelayState') &&
      jwt
  ) {
    redirectAuthSAML(next, queryString)
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAppMobile = ['androidOS','iOS'].includes(queryString.queryPath.so)
    if (isAppMobile && jwt && to.name === 'mobileLoginSuccess') {
      return next()
    }
  }

  if (
    (jwt != '' &&
      to.name == 'login' &&
      firstLogin === 1 &&
      notOnboarding === true &&
      checkUserEmployee === true) ||
    (jwt != '' &&
      to.name == 'resetpass' &&
      firstLogin === 1 &&
      notOnboarding === true &&
      checkUserEmployee === true)
  ) {
    if (queryString.has('factory')) {
      store.dispatch('auth/setParamLoginFactory', queryString.queryPath.factory)
    }
    const isInIframe = window.self !== window.top;
    if (isInIframe) {
      const actions = store.state.actions || [];
      const actionsIds = actions.map(action => action.id);
      const isApprover = actionsIds.includes('71');
      
      if (isApprover) {
        return next({ name: 'licensesManager' });
      } else {
        return next({ name: 'licenses' });
      }
    }
    next('/')
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (
      jwt == '' ||
      (jwt == '' && to.name == '404') ||
      firstLogin === 0 ||
      notOnboarding === false
    ) {
      next('/auth')
    } else if (checkUserEmployee === false && to.name !== 'rrhhredirect') {
      router.push({ name: 'rrhhredirect' })
      // next('/rrhhredirect')
    } else if (
      to.matched.some(record =>
        record.name.toLocaleLowerCase().includes('licenses')
      ) &&
      !licensesAccess
    ) {
      next('/403')
    } else if (to.matched.some(record => record.meta.requiresPermission)) {
      // next();
      if (store.getters.getActions.length > 0) {
        let entryAction = false
        for (let key in store.getters.getActions) {
          if (String(store.getters.getActions[key].id).includes(String(to.meta.action))) {
            entryAction = true
          }
        }
        if (entryAction === false) {
          next('/403')
        } else {
          next()
        }
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

const redirectAuthSAML = (next, queryParamsSAML) => {
  try {
    next({
      name: 'authSAML',
      params: { queryParamsSAML: queryParamsSAML }
    })
  } catch (e) {
    next()
  }
}
export default router